import React, { useState, Fragment, useContext } from 'react';
import { Menu, Transition } from '@headlessui/react';
import LanguageContext from 'context/LanguageContext';
import { useNavigate } from 'react-router-dom';

import { BsChevronDown } from 'react-icons/bs';

import '/node_modules/flag-icons/css/flag-icons.min.css';
import { It, Gb } from 'react-flags-select';

export default function LanguageSelector() {
  const { language, setLanguage } = useContext(LanguageContext);
  const [selectedFlag, setSelectedFlag] = useState(<It />);
  const navigate = useNavigate();

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="flex items-center justify-start gap-2 py-2 rounded-md">
          {selectedFlag} <BsChevronDown />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 w-auto px-3 mt-2 text-black origin-top-right bg-white rounded-md shadow-lg">
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <span
                  className={
                    'cursor-pointer flex items-center font-bold justify-start gap-2 px-4 py-2 text-sm'
                  }
                  onClick={() => {
                    setSelectedFlag(<It />);
                    navigate('/');
                    setLanguage('it');
                  }}
                >
                  <It /> IT
                </span>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <span
                  className={
                    'cursor-pointer flex items-center font-bold justify-start gap-2 px-4 py-2 text-sm'
                  }
                  onClick={() => {
                    setSelectedFlag(<Gb />);
                    navigate('/');
                    setLanguage('en');
                  }}
                >
                  <Gb /> EN
                </span>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
